// extracted by mini-css-extract-plugin
export var cancelButton = "_ln-5";
export var content = "_ln-3";
export var createButton = "_ln-6";
export var drawerContainer = "_ln-0";
export var footer = "_ln-2";
export var header = "_ln-1";
export var orderFormColumn = "_ln-4";